import { render, staticRenderFns } from "./WeeklyInners.vue?vue&type=template&id=24270ab7&scoped=true"
import script from "./WeeklyInners.vue?vue&type=script&lang=js"
export * from "./WeeklyInners.vue?vue&type=script&lang=js"
import style0 from "./WeeklyInners.vue?vue&type=style&index=0&id=24270ab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24270ab7",
  null
  
)

export default component.exports